import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import AppTheme from "../components/shared-theme/AppTheme";
import { chartsCustomizations } from "../components/dashboard/theme/customizations";
import { dataGridCustomizations } from "../components/dashboard/theme/customizations/dataGrid";
import MainGrid from "../components/user-management/components/MainGrid";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
};

export default function UserManagement(props: {
  disableCustomTheme?: boolean;
}) {
  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: "flex" }}>
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: "auto",
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: "center",
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <MainGrid />
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}
